import React from 'react';
import './Reception.css';
import bannerImage from './assets/reception.jpg'; // Banner still imported

const ReceptionPage = () => {
  return (
    <div className="reception-page">

      {/* 1. Welcome Section */}
      <section className="welcome-banner">
        <img src={bannerImage} alt="Reception Banner" className="banner-image" />
        <div className="banner-overlay">
          <h1>Welcome to the Reception</h1>
          <p>This is where every client’s journey to better health begins.</p>
        </div>
      </section>

      {/* 2. Nurse Video Explanation */}
      <section className="video-section">
  <h2>🎥 Reception Walkthrough by Our Nurse</h2>
  <p className="video-caption">
    Watch as our nurse explains the step-by-step process we follow when you visit our reception area.
  </p>
  <div className="video-wrapper">
    <video
      controls
      playsInline
      preload="metadata"
      className="nurse-video"
    >
      <source
        src="https://res.cloudinary.com/dfbgpqygq/video/upload/v1749724819/reception-nurse_wvhyf9.mp4"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>
  </div>
</section>


      {/* 3. FAQs */}
      <section className="faq-section">
        <h2>🧠 Frequently Asked Questions (FAQs)</h2>
        <ul className="faq-list">
          <li><strong>How long will the reception process take?</strong><br />Most clients are served within 10–15 minutes.</li>
          <li><strong>Do I need to fast before coming?</strong><br />No. However, you may be asked to fast later if a lab test is required.</li>
          <li><strong>Is everything free?</strong><br />Initial tests like BP and blood sugar are free. Lab services are offered at affordable rates.</li>
          <li><strong>Can I bring someone with me?</strong><br />Yes, we encourage clients to come with a friend or family member if they wish.</li>
        </ul>
      </section>

    </div>
  );
};

export default ReceptionPage;
